
/**
 * Exception thrown when car is not set
 */
export class CarNotSetException extends Error{
    constructor() {
        super('Car is currently not set');
    }
}